import type { SearchArtistItemDto } from '@customTypes/types';
import { ArrowRightIcon, MapPinIcon } from '@heroicons/react/24/outline';
import { Badge, Card, Flex, Image, Text, Title } from '@mantine/core';
import { FormattedMessage } from 'react-intl';

import { resolveImagePath } from '@/shared/helper/resolveImagePath';
import { translate } from '@/shared/i18n/translate';
import { LBActionButton } from '@/shared/ui-kit/components';

import styles from './ArtistCard.module.css';

type LBArtistCardProps = { data: SearchArtistItemDto; navigate?: () => void };

export const LBArtistCard = ({ data, navigate }: LBArtistCardProps) => (
  <Card className={styles.container} onClick={navigate}>
    <Card.Section className={styles.imageContainer}>
      {data.searchPhoto && (
        <Image
          className={styles.image}
          height={300}
          src={
            data.searchPhoto.thumbnailPath &&
            resolveImagePath(data.searchPhoto.thumbnailPath)
          }
        />
      )}
      <Badge className={styles.badge}>
        <FormattedMessage id={`commons.artistStatuses.${data.profileStatus}`} />
      </Badge>
      <LBActionButton
        className={styles.actionIcon}
        variant='filled'
        onClick={navigate}
      >
        <ArrowRightIcon height={18} width={18} />
      </LBActionButton>
    </Card.Section>

    <Flex align='end' justify='space-between' pt={22}>
      <Flex direction='column' gap={4}>
        <Title order={6}>{`${data.firstName}`}</Title>
        <Flex direction='row' gap={8} wrap='nowrap'>
          {data.isLookingForHostessVacancy && (
            <Text c='blue' fz={14}>
              <FormattedMessage id='commons.artistJobs.Hostess' />
            </Text>
          )}
          {data.isLookingForGoGoVacancy && (
            <Text c='blue' fz={14}>
              <FormattedMessage id='commons.artistJobs.GoGo' />
            </Text>
          )}
          {data.isLookingForStripVacancy && (
            <Text c='blue' fz={14}>
              <FormattedMessage id='commons.artistJobs.Strip' />
            </Text>
          )}
        </Flex>

        {data.hasWorkingExperience ? (
          <Text c='gray' fz={14}>
            {translate('commons.withExperience')}
          </Text>
        ) : (
          <Text c='gray' fz={14}>
            {translate('commons.withouthExperience')}
          </Text>
        )}
      </Flex>

      <Flex direction='column' gap={4}>
        <Flex gap={4} justify='end'>
          <MapPinIcon height={18} width={18} />
          <Text c='gray' fz={14}>
            {data.countryOfResidence}
          </Text>
        </Flex>

        {/* // citizenships block */}

        {/* <Flex align="end" direction="column" gap={4}> */}
        {/*   <Text c="gray" fz={14}> */}
        {/*     {translate('commons.citizenship')}: */}
        {/*   </Text> */}
        {/*   <Flex align="end" direction="column" gap={4}> */}
        {/*     {Array.isArray(data.citizenships) && data.citizenships.length > 0 ? ( */}
        {/*       data.citizenships.map((country: string, index: number) => ( */}
        {/*         <Badge key={`${country}-${index}`} size="sm" variant="light"> */}
        {/*           {country} */}
        {/*         </Badge> */}
        {/*       )) */}
        {/*     ) : ( */}
        {/*       <Badge size="sm" variant="light">{translate('commons.notSpecified')}</Badge> */}
        {/*     )} */}
        {/*   </Flex> */}
        {/* </Flex> */}
      </Flex>
    </Flex>
  </Card>
);
